export default "__VITE_ASSET__0fafdfc1__"